import React from 'react';
import TeaserSection from '~/src/components/teaser/section/TeaserSection';
import {TeaserTypes} from '~/src/utilities/constants/types';
import {TeaserFormat} from '~/src/utilities/constants/formats';
import {createFormat} from '~/src/utilities/feed/format';

const TeaserSectionPlaceholder = () => {
    const elements = [...Array(8).keys()].map((i) => {
        return {
            type: TeaserTypes.PLACEHOLDER,
            format: i === 0 ? createFormat(TeaserFormat.TEASER_LARGE) : createFormat(TeaserFormat.TEASER_SMALL)
        };
    });

    return <TeaserSection elements={elements} isPlaceholder={true} />;
};

export default TeaserSectionPlaceholder;
